export default __webpack_public_path__ + "static/media/office_enter.d24020f0.svg";